import(/* webpackMode: "eager" */ "/home/runner/work/buildmind-watcher-ai/buildmind-watcher-ai/app/(stellar)/layout.tsx")